import { render, staticRenderFns } from "./OrderCardWrapper.vue?vue&type=template&id=57887b8e&scoped=true&"
import script from "./OrderCardWrapper.vue?vue&type=script&lang=js&"
export * from "./OrderCardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./OrderCardWrapper.vue?vue&type=style&index=0&id=57887b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57887b8e",
  null
  
)

export default component.exports